var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", [
    _c(
      "form",
      {
        staticClass: "m-form m-form--state",
        on: {
          submit: function($event) {
            $event.preventDefault()
            return _vm.submitForm.apply(null, arguments)
          }
        }
      },
      [
        _c("div", { staticClass: "modal-body" }, [
          _c("div", { staticClass: "m-portlet__body" }, [
            _c("label", { attrs: { for: "camera_name" } }, [
              _c("b", [
                _vm._v(
                  _vm._s(_vm.camera_name) + " - " + _vm._s(_vm.control_point)
                )
              ])
            ]),
            _vm._v(" "),
            _vm.camera_status == "on"
              ? _c(
                  "div",
                  {
                    staticStyle: {
                      "text-align": "center",
                      "border-style": "double",
                      "background-color": "black"
                    }
                  },
                  [_c("img", { attrs: { src: _vm.picture, width: "400" } })]
                )
              : _c("div", [
                  _vm.camera_status == "off"
                    ? _c(
                        "div",
                        {
                          staticStyle: {
                            "text-align": "center",
                            "line-height": "150px",
                            "border-style": "double",
                            "background-color": "black",
                            color: "white",
                            height: "150px"
                          }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm._f("capitalize")(
                                  _vm._f("translate")("camera_connection_error")
                                )
                              ) +
                              "\n          "
                          )
                        ]
                      )
                    : _vm._e()
                ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "modal-footer" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-primary-orange",
              attrs: { type: "button" },
              on: { click: _vm.testCam }
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_vm._f("capitalize")(_vm._f("translate")("test"))) +
                  "\n      "
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-secondary",
              attrs: {
                type: "button",
                "data-dismiss": "modal",
                id: "btn-cancel-approve"
              },
              on: { click: _vm.close }
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_vm._f("capitalize")(_vm._f("translate")("close"))) +
                  "\n      "
              )
            ]
          )
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2f671440", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f671440","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/src/components/admin/cameras/TestCamera.vue
// module id = 431
// module chunks = 0 1 56 167